import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { VERSIONS } from '../../resources/constants';
import { getCurrentVersion, getVersionName, ImgWithFallback } from '../../resources/utils';
import { ApplicationState } from '../../store/types';

interface IProps {
    image: string;
    texts: string[];
    schoolName?: string;
}

type Props = IProps;

// const defaultProps = {
//     texts: [''],
//     schoolName: '',
// };

function HeaderImage(props: Props) {
    const {
        image, texts, schoolName,
    } = props;
    const intl = useIntl();
    const currentSchool = useSelector((state: ApplicationState) => state.navigation.currentSchool);
    const generalMedia = useSelector((state: ApplicationState) => state.navigation.generalMedia);
    const params = useParams<{ lang: string }>();
    const platform = getVersionName();
    // Prepare image to <ImgWithFallback />
    const imageSource = image;
    const re = /(?:\.([^.]+))?$/;
    const imageSourceExploded = re.exec(imageSource);
    const ext = imageSourceExploded != null ? imageSourceExploded[1] : '';
    const imageSrc = imageSource;
    const imageFallback = ext === 'webp' ? `${imageSource.slice(0, -4)}jpg` : imageSource;
    // End of prepare image to <ImgWithFallback />

    const customLink = (currentSchool && currentSchool.header_link)
        || (generalMedia && generalMedia.header_link)
        || undefined;
    const isExternalLink = customLink !== undefined && /^(https?:)?\/\//.test(customLink);
    const canNavigateToProducts = currentSchool && currentSchool.online_purchase;
    let headerLink;
    if (customLink) {
        headerLink = isExternalLink ? customLink : `/${params.lang}/${customLink.replace(/^\/+/, '')}`;
    } else if (canNavigateToProducts) {
        headerLink = `/${params.lang}/products`;
    }

    const firstText = (texts && texts[0]) || '';
    const title = (
        <h1
            className="__header-image-label-1"
            style={{ cursor: headerLink ? 'pointer' : 'default' }}
        >
            {/* eslint-disable-next-line no-nested-ternary */}
            {`${schoolName
                ? firstText
                : getCurrentVersion() === VERSIONS.BookingSport
                    ? intl.formatMessage({ id: 'landing.bookingsport' })
                    : firstText.substr(0, firstText.lastIndexOf(' '))
            } ${schoolName || ''}`}
        </h1>
    );

    let titleNode = title;
    if (headerLink !== undefined) {
        titleNode = isExternalLink
            ? <a className="__header-image-label-link" href={headerLink}>{title}</a>
            : <Link className="__header-image-label-link" to={headerLink}>{title}</Link>;
    }

    return (
        <div className="__header-parent">
            <ImgWithFallback
                src={imageSrc}
                fallback={imageFallback}
                className="__header-image"
                alt={`${intl.formatMessage({ id: 'img.alt.logo' })} ${platform}`}
            />
            {texts && texts.length > 0
                ? (
                    <div>
                        {getCurrentVersion() === VERSIONS.BookingFormation ? null : titleNode}
                        <h2 className="__header-image-label-2">{texts[1]}</h2>
                    </div>
                )
                : null}
        </div>
    );
}

// HeaderImage.defaultProps = defaultProps;

export default HeaderImage;
